import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const FinancePage = lazyLoad(
    () => import('./index'),
    module => module.FinancePage,
    { fallback: <LoadingSpinner /> },
);
